import { MetaData } from '../meta-data';

import * as Styled from './company-loggedout.styles';

export const CompanyLoggedoutHeadline = ({
  headerText,
  secondaryHeader,
  companyType,
}: {
  headerText: string;
  secondaryHeader?: JSX.Element;
  companyType: 'industry' | 'most-visited' | 'recently-claimed';
}) => {
  return (
    <>
      <MetaData index title={headerText} description={headerText} />
      <Styled.Headline
        size="medium"
        as="h1"
        className={
          companyType === 'industry' ? 'industry-company-headline' : undefined
        }
      >
        {headerText}
      </Styled.Headline>
      {secondaryHeader}
    </>
  );
};
